import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import "./CreateBrand.scss";
import "../../styles/global.scss";
import Cookies from "js-cookie";

// React Bootstrap components
import { Container, Row, Col } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

//Components
import { GetUserProfile } from "../../API/endpoints/User";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/header/NavBar";
import BasicInfo from "./BasicInfo";
import ExpansionSetup from "./ExpansionSetup";
import FocusCategory from "./FocusCategory";
import EngagementTerms from "./EngagementTerms";
import { GetBrand } from "../../API/endpoints/Brands";

function CreateNewBrand() {
  const navigate = useNavigate();
  const params = useParams();
  const [defaultTab, setDefaultTab] = useState<any>("organization-info");
  const [brandName, setBrandName] = useState<string>("");
  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [brandId, setBrandId] = useState<string>("");
  const [selectYearsOperations, setSelectYearsOperations] = useState("");
  const [currentRevenueStatus, setCurrentRevenueStatus] = useState("");
  const [focusCategories, setFocusCategories] = useState<any[]>([]);
  const [engagementTerms, setEngagementTerms] = useState<any>({});
  const [expansionSetupData, setExpansionSetupData] = useState<any>([]);
  const [selectOrg, setSelectOrg] = useState("");

  const [socialLinks, setSocialLinks] = useState([
    { platform: "linkedin", url: "" },
  ]);
  const [marketplaces, setMarketplaces] = useState([
    { platform: "Amazon", url: "" },
  ]);

  const [selectedEngagementModel, setSelectedEngagementModel] =
    useState<string>("");
  const [selectedExclusivityTenure, setSelectedExclusivityTenure] =
    useState<string>("");
  const [selectedFobCifPreference, setSelectedFobCifPreference] =
    useState<string>("");
  const [selectedMarketingInvestment, setSelectedMarketingInvestment] =
    useState<string>("");

  const [selectedHealthOptions, setSelectedHealthOptions] = useState<string[]>(
    []
  );
  const [healthChecked, setHealthChecked] = useState(false);
  const [healthOtherValue, setHealthOtherValue] = useState("");

  const [selectedBeautyOptions, setSelectedBeautyOptions] = useState<string[]>(
    []
  );
  const [beautyChecked, setBeautyChecked] = useState(false);
  const [beautyOtherValue, setBeautyOtherValue] = useState("");

  const [selectedFoodOptions, setSelectedFoodOptions] = useState<string[]>([]);
  const [foodChecked, setFoodChecked] = useState(false);
  const [foodOtherValue, setFoodOtherValue] = useState("");

  const [selectedPetOptions, setSelectedPetOptions] = useState<string[]>([]);
  const [petChecked, setPetChecked] = useState(false);
  const [petOtherValue, setPetOtherValue] = useState("");

  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          // setRoleID(response.data?.user_roles[0]?.roles.id);
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID, navigate]);

  useEffect(() => {
    if (params?.brandId) {
      GetBrand(params?.brandId)
        .then((res: any) => {
          const brand = res.data;

          setBrandId(brand.id);
          setBrandName(brand.brand_name);
          setSelectYearsOperations(brand.years_of_operation);
          setCurrentRevenueStatus(brand.current_revenue);
          setEngagementTerms(brand.brand_preference);
          setExpansionSetupData(brand.market_preference);

          // Social links (ensure format: [{ platform: ..., url: ... }])
          setSocialLinks(
            brand.social_media?.length
              ? brand.social_media.map((item: any) => ({
                platform: item.platform,
                url: item.url,
              }))
              : [{ platform: "iinkedin", url: "" }] // default fallback
          );

          // Marketplaces (ensure format: [{ platform: ..., url: ... }])
          setMarketplaces(
            brand.market_place?.length
              ? brand.market_place.map((item: any) => ({
                platform: item.platform,
                url: item.url,
              }))
              : [{ platform: "Amazon", url: "" }] // default fallback
          );

          const focusCategoryFormatted =
            brand.brand_categories?.map((item: any) => ({
              category: item.focus_category,
              sub_category: item.sub_categories || [],
            })) || [];

          setFocusCategories(focusCategoryFormatted);
        })
        .catch((err: any) => {
          console.error(err, "error in getting brand data");
        });
    }
  }, [params?.brandId]);

  return (
    <Container fluid className="createbrand">
      <Row>
        {/* <Col className="sidebar">
          <Sidebar active="brand" />
        </Col> */}
        <Col className="content-main p-0">
          <Navbar userProfile={userProfile} />
          <Container className="bg-[#F1F2F7] w-[100%] max-w-[100%] parent-container">
            <Row>
              <Col className="breadcrumb-nav">
                <Breadcrumb>
                  <Breadcrumb.Item className="font12-regular gray-500 underline">
                    <div onClick={() => navigate(-1)}>
                      BRANDS
                    </div>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active className="font12-medium gray-800">
                    {params?.brandId ? "EDIT BRAND" : "ADD NEW BRAND"}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
            <Row className="tabs-row bg-white !p-[0] max-w-[1024px] m-[16px_auto_0] ">
              <p className="p-[16px] m-[0] text-[#1D2939] text-[14px] font-[500] ">
                {params?.brandId ? "Edit Brand" : "Add New Brand"}
              </p>
              <Col className="p-0">
                <Tabs
                  //     activeKey={params?.brandid ? undefined : defaultTab}
                  id="controlled-tab"
                  activeKey={defaultTab}
                  onSelect={(k) => {
                    if (params?.brandId) {
                      setDefaultTab(k);
                    }
                  }}
                  className="tabs-global"
                  fill
                >
                  <Tab
                    eventKey="organization-info"
                    disabled={params?.brandId ? false : true}
                    className="adminusersTabSelectorClass"
                    title={
                      <React.Fragment>
                        <div>Basic Info</div>
                      </React.Fragment>
                    }
                  >
                    <BasicInfo
                      setDefaultTab={setDefaultTab}
                      setBrandId={setBrandId}
                      brandName={brandName}
                      setBrandName={setBrandName}
                      selectYearsOperations={selectYearsOperations}
                      setSelectYearsOperations={setSelectYearsOperations}
                      currentRevenueStatus={currentRevenueStatus}
                      setCurrentRevenueStatus={setCurrentRevenueStatus}
                      socialLinks={socialLinks}
                      setSocialLinks={setSocialLinks}
                      marketplaces={marketplaces}
                      setMarketplaces={setMarketplaces}
                      setSelectOrg={setSelectOrg}
                    />
                  </Tab>
                  <Tab
                    eventKey="focus-category"
                    disabled={params?.brandId ? false : true}
                    className="adminusersTabSelectorClass"
                    title={
                      <React.Fragment>
                        <div>Focus Category</div>
                      </React.Fragment>
                    }
                  >
                    <FocusCategory
                      setDefaultTab={setDefaultTab}
                      brandName={brandName}
                      selectYearsOperations={selectYearsOperations}
                      currentRevenueStatus={currentRevenueStatus}
                      socialLinks={socialLinks}
                      marketplaces={marketplaces}
                      setBrandId={setBrandId}
                      focusCategories={focusCategories}
                      selectOrg={selectOrg}
                      selectedHealthOptions={selectedHealthOptions}
                      setSelectedHealthOptions={setSelectedHealthOptions}
                      healthChecked={healthChecked}
                      setHealthChecked={setHealthChecked}
                      healthOtherValue={healthOtherValue}
                      setHealthOtherValue={setHealthOtherValue}
                      selectedBeautyOptions={selectedBeautyOptions}
                      setSelectedBeautyOptions={setSelectedBeautyOptions}
                      beautyChecked={beautyChecked}
                      setBeautyChecked={setBeautyChecked}
                      beautyOtherValue={beautyOtherValue}
                      setBeautyOtherValue={setBeautyOtherValue}
                      selectedFoodOptions={selectedFoodOptions}
                      setSelectedFoodOptions={setSelectedFoodOptions}
                      foodChecked={foodChecked}
                      setFoodChecked={setFoodChecked}
                      foodOtherValue={foodOtherValue}
                      setFoodOtherValue={setFoodOtherValue}
                      selectedPetOptions={selectedPetOptions}
                      setSelectedPetOptions={setSelectedPetOptions}
                      petChecked={petChecked}
                      setPetChecked={setPetChecked}
                      petOtherValue={petOtherValue}
                      setPetOtherValue={setPetOtherValue}
                    />
                  </Tab>
                  <Tab
                    eventKey="engagement-terms"
                    disabled={params?.brandId ? false : true}
                    className="adminusersTabSelectorClass"
                    title={
                      <React.Fragment>
                        <div>Engagement Terms</div>
                      </React.Fragment>
                    }
                  >
                    <EngagementTerms
                      setDefaultTab={setDefaultTab}
                      selectedEngagementModel={selectedEngagementModel}
                      setSelectedEngagementModel={setSelectedEngagementModel}
                      selectedExclusivityTenure={selectedExclusivityTenure}
                      setSelectedExclusivityTenure={
                        setSelectedExclusivityTenure
                      }
                      selectedFobCifPreference={selectedFobCifPreference}
                      setSelectedFobCifPreference={setSelectedFobCifPreference}
                      selectedMarketingInvestment={selectedMarketingInvestment}
                      setSelectedMarketingInvestment={
                        setSelectedMarketingInvestment
                      }
                      engagementTerms={engagementTerms}
                    />
                  </Tab>
                  <Tab
                    eventKey="expansion-setup"
                    disabled={params?.brandId ? false : true}
                    className="adminusersTabSelectorClass"
                    title={
                      <React.Fragment>
                        <div>Expansion Setup</div>
                      </React.Fragment>
                    }
                  >
                    <ExpansionSetup
                      brandID={brandId}
                      setDefaultTab={setDefaultTab}
                      selectedEngagementModel={selectedEngagementModel}
                      selectedExclusivityTenure={selectedExclusivityTenure}
                      selectedFobCifPreference={selectedFobCifPreference}
                      selectedMarketingInvestment={selectedMarketingInvestment}
                      expansionSetupData={expansionSetupData}
                      selectedHealthOptions={selectedHealthOptions}
                      brandName={brandName}
                      healthChecked={healthChecked}
                      selectedBeautyOptions={selectedBeautyOptions}
                      beautyChecked={beautyChecked}
                      selectedFoodOptions={selectedFoodOptions}
                      foodChecked={foodChecked}
                      selectedPetOptions={selectedPetOptions}
                      petChecked={petChecked}
                      selectYearsOperations={selectYearsOperations}
                      currentRevenueStatus={currentRevenueStatus}
                      marketplaces={marketplaces}
                      socialLinks={socialLinks}
                      setBrandId={setBrandId}
                      selectOrg={selectOrg}
                    />
                  </Tab>
                </Tabs>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}

export default CreateNewBrand;
